/**
 * Unified toaster.
 *
 * One toast for the whole theme (replaces the wishlist notification bar, the
 * form success-message snippet, and the contact-form inline success markup).
 *
 * Usage:
 *   window.toast.show('Message', {
 *     type: 'info' | 'success' | 'error',   // visual accent (default 'info')
 *     icon: 'heart' | 'broken-heart' | 'info' | 'success' | 'error' | 'email',
 *     action: { label: 'Undo', onClick: fn } | { label: 'See', href: '/x' },
 *     duration: 4000,                        // ms; 0 keeps it until hide()
 *   });
 *   window.toast.hide();
 *
 * Or declaratively:  document.dispatchEvent(new CustomEvent('toast:show', { detail: { message, ...opts } }))
 */
(function () {
  const ICONS = {
    heart:
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.5 4.3 12.8a4.5 4.5 0 0 1 6.4-6.4l1.3 1.3 1.3-1.3a4.5 4.5 0 0 1 6.4 6.4L12 20.5Z" fill="currentColor"/></svg>',
    'broken-heart':
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.5 4.3 12.8a4.5 4.5 0 0 1 6.4-6.4l.8.8-1.5 3 2.5 2-2 2.3L12 20.5Z" fill="currentColor"/><path d="M12.7 7.2a4.5 4.5 0 0 1 6.4 6.4l-3.6 3.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    info:
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 11v5M12 8h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    success:
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="m8.5 12.5 2.3 2.3 4.7-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    error:
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 7.5v5M12 16h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    email:
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="m4 7 8 6 8-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  let timer;

  const getEl = () => document.getElementById('brn-toaster');

  function show(message, opts = {}) {
    const el = getEl();
    if (!el || !message) return;

    const { type = 'info', icon, action, duration = 4000 } = opts;

    const iconHtml = icon && ICONS[icon] ? `<span class="brn-toaster__icon">${ICONS[icon]}</span>` : '';

    let actionHtml = '';
    if (action && action.label) {
      actionHtml = action.href
        ? `<a class="brn-toaster__action" href="${action.href}">${action.label}</a>`
        : `<button type="button" class="brn-toaster__action">${action.label}</button>`;
    }

    el.className = `brn-toaster brn-toaster--${type}`;
    el.innerHTML = `<div class="brn-toaster__content">${iconHtml}<p class="brn-toaster__text">${message}</p>${actionHtml}</div>`;

    if (action && !action.href && typeof action.onClick === 'function') {
      el.querySelector('.brn-toaster__action')?.addEventListener('click', (e) => {
        e.preventDefault();
        action.onClick();
        hide();
      });
    }

    requestAnimationFrame(() => el.classList.add('brn-toaster--visible'));

    clearTimeout(timer);
    if (duration) timer = setTimeout(hide, duration);
  }

  function hide() {
    getEl()?.classList.remove('brn-toaster--visible');
    clearTimeout(timer);
  }

  window.toast = { show, hide };

  document.addEventListener('toast:show', (e) => {
    const detail = e.detail || {};
    show(detail.message, detail);
  });
})();
